
import { defineComponent } from 'vue';

import { header } from '@/common/seo';
import { setCommonParamsCookiesInServer } from '@/common/common-params';

import { POLICY_ENUM } from './policy.vue';

const POLICY_MAP = {
    [POLICY_ENUM.PRIVACY_POLICY]: 'https://keda.kwai.com/pages/187/393b9640?env=1&isPc=1',
    [POLICY_ENUM.TERMS_OF_SERVICE]: 'https://keda.kwai.com/pages/187/7c291220?env=1&isPc=1',
};

export default defineComponent({
    layout(ctx) {
        return ctx.$pwaLayout || 'default';
    },
    setup() {},
    asyncData(ctx) {
        if (process.server) {
            const { startup } = ctx?.store?.state || {};
            setCommonParamsCookiesInServer({
                ctx,
                bucket: startup?.bucket,
                host: ctx.req.headers.host,
                countryInfo: startup?.countryInfo,
            });
        }
        const policyKey = ctx?.route?.params?.policyKey;
        const policyUrl = POLICY_MAP?.[policyKey as keyof typeof POLICY_MAP];
        if (!policyUrl) {
            ctx.redirect('/not-found');
            return;
        }

        return {
            policyUrl,
            title: ctx?.i18n?.t?.('terms_policies'),
        };
    },
    head() {
        return header(this);
    },
});
